import { Box, Typography } from "@material-ui/core";
import { ArrowBack } from "@material-ui/icons";
import clsx from "clsx";
import React from "react";
import useStyles from "../../../styles/components/Navbar";

type NavbarDefaultType = {
  title: string;
  onClickBack?: () => void;
};

const NavbarDefault = (props: NavbarDefaultType) => {
  const { title, onClickBack } = props;
  const classes = useStyles(props);

  return (
    <Box className={classes.navbarWrapper}>
      <Box
        className={clsx(classes.navbarContent, classes.navbarDefaultWrapper)}
      >
        {onClickBack && (
          <ArrowBack
            className={classes.icon}
            onClick={() => {
              onClickBack();
            }}
          />
        )}
        <Typography className={classes.navbarTitle}>{title}</Typography>
      </Box>
    </Box>
  );
};

export default NavbarDefault;
